import React from 'react'

import { IChildrenBaseProps } from './types'

interface IProps extends IChildrenBaseProps {
  mainClass?: string
  iconClass?: string
  note?: string
  label: string
  link: string
  rf?: string
  ariaLabel?: string
  tabIndex?: number
  onClick?: () => void
}

const Button = ({ mainClass, iconClass, label, link, note, rf, ariaLabel, tabIndex, onClick }: IProps) => (
  <div className={mainClass || 'csas-claim csas-center'}>
    <a
      onClick={onClick && onClick}
      href={link}
      className='csas-click csas-click--red csas-click-with-icon csas-mb-xs'
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      data-testid={rf}
    >
      {iconClass && <i className={iconClass}></i>}
      {label}
    </a>
    {note && <div className='csac-claim-text'>{note}</div>}
  </div>
)

export { Button, IProps }
